// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15EUo","footer":"styles_footer__32OqL","passCodeTooltip":"styles_passCodeTooltip__H52qw"};